import { Typography } from "@mui/joy";
import React, { useState, useEffect } from "react";

const TimeAgo = ({ timestamp, currentLanguageData }) => {
    const calculateTimeAgo = () => {
        const now = new Date().setSeconds(new Date().getSeconds() + 5);
        const date = new Date(timestamp);
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) {
            return `${diffInSeconds} ${currentLanguageData.sec}`;
        }

        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `${diffInMinutes} ${currentLanguageData.min}`;
        }

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `${diffInHours} ${currentLanguageData.hr}`;
        }

        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 30) {
            return `${diffInDays} ${currentLanguageData.day}`;
        }

        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return `${diffInMonths} ${currentLanguageData.month}`;
        }

        const diffInYears = Math.floor(diffInMonths / 12);
        return `${diffInYears} ${currentLanguageData.year}`;
    };

    const [timeAgo, setTimeAgo] = useState(calculateTimeAgo);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeAgo(calculateTimeAgo());
        }, 1000);

        return () => clearInterval(interval);
    }, [timestamp]);

    return <Typography level="body-xs">{timeAgo}</Typography>;
};

export default TimeAgo;
